import { useEffect } from "react";
import PropTypes from "prop-types";

// PMS components
import MDBox from "components/MDBox";

// PMS context
import { useMaterialUIController, setLayout } from "context";

function CustomerDashboardLayout({ children }) {
  const [, dispatch] = useMaterialUIController();

  useEffect(() => {
    setLayout(dispatch, "customerDashboard");
  }, [dispatch]);

  return (
    <MDBox
      sx={{
        maxWidth: 400,
        mx: "auto", // center horizontally
        width: "100%",
      }}
    >
      {children}
    </MDBox>
  );
}

// Typechecking props
CustomerDashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CustomerDashboardLayout;
